export class AppointmentDataModel {
    date: string;
    ScheduleTime: string;
    doctorName: string;
    department: string;
    status: string;
	RequestNo : string;
	PaymentStatus : string;
	ConsultationFees : string;
	AppointmentNo : string;
    DoctorCode: string;
    appPatientid: string;
    IsValiddate: boolean;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/appointments/appointmentsdatamodel.ts